import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
} from "react-bootstrap";
import { FloatInput, HeadPage } from "src/componentes";
import SistemaCadastroCode from "./SistemaCadastro.Code";

const SistemaCadastroView = () => {
  const {
    loading,
    onSubmit,
    handleSubmit,
    errors,
    register,
    setValue,
    subModulo,
    configuracaoOptions,
  } = SistemaCadastroCode();

  return (
    <Container>
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <HeadPage headText="Cadastro de Configuração Fiscal" />
        {!loading ? (
          <>
            <Row>
              <Col xs={12} sm={6} md={4} lg={4}>
                <Form.Group controlId="subModulo">
                  <Form.Label>Submódulo</Form.Label>
                  <Form.Select
                    {...register("subModulo", { valueAsNumber: true })}
                    onChange={(e) => {
                      setValue("subModulo", Number(e.target.value));
                      setValue("tipoConfiguracao", undefined as any);
                    }}
                    isInvalid={!!errors.subModulo}
                  >
                    <option value="">Selecione</option>
                    <option value={1}>NFCe</option>
                    <option value={2}>NFe</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.subModulo?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={4} lg={4}>
                <Form.Group controlId="configuracao">
                  <Form.Label>Configuração</Form.Label>
                  <Form.Select
                    {...register("tipoConfiguracao")}
                    onChange={(e) =>
                      setValue("tipoConfiguracao", Number(e.target.value))
                    }
                    isInvalid={!!errors.tipoConfiguracao}
                  >
                    <option value="">Selecione</option>
                    {subModulo &&
                      configuracaoOptions[subModulo]?.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.tipoConfiguracao?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={4} lg={4}>
                <Form.Group controlId="valor">
                  <Form.Label>Valor</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("configuracaoValor")}
                    isInvalid={!!errors.configuracaoValor}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.configuracaoValor?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FloatInput
                  label="Usuário Id (opcional)"
                  errorsMessage={errors.usuarioId}
                  registerField={register("usuarioId")}
                  inputMask="int"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="d-grid mt-3 mb-5">
                <Button type="submit">Confirmar</Button>
              </Col>
            </Row>
          </>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default SistemaCadastroView;
